const Global = (() => {
    window.ascscale_img_path = null;
})();

export default Global;
